// @flow

import { type WebsiteChatConfig } from '@chatchamp/chatchamp-types'

export const CUSTOM_WEBSITE_CHAT_CONFIG = 'chatchamp-chatbot-custom-website-chat-config'

export function mergeWebsiteChatConfig (websiteChatConfig: WebsiteChatConfig, customWebsiteChatConfig: $Shape<WebsiteChatConfig>): WebsiteChatConfig {
  return Object.assign({}, websiteChatConfig, customWebsiteChatConfig)
}
